import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import {  Card,
  CardContent,
  Typography,
  Alert,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import SignupSuccessPopup from "../../../components/Popups/SignupSuccessPopup";

const VendorItemMapping = ({ org_token, auth_token, vendorToken,user_token }) => {
  const [itemsData, setItemsData] = useState([]);
 const [selectedCategory, setSelectedCategory] = useState("");
const [selectedItem, setSelectedItem] = useState("");

const [mappedItems, setMappedItems] = useState([]);

const [successMessage, setSuccessMessage] = useState("");
const [status, setStatus] = useState({
  show: false,
  type: "success", 
  message: "",
});


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  

  useEffect(() => {
    if (!org_token || !auth_token) return;

    const fetchItems = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("org_token", org_token);
        // formData.append("page", 1);
        const res = await axios.post(
          API_ENDPOINT.buyer_all_item_list,
          formData,
          { headers: { Authorization: `Bearer ${auth_token}` } }
        );

        setItemsData(res?.data?.results || []);
      } catch {
        setError("Failed to load items");
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [org_token, auth_token]);


  useEffect(() => {
  if (!vendorToken || !auth_token) return;

  const fetchMappedItems = async () => {
    try {
      const res = await axios.post(
        API_ENDPOINT.vendors_item_mapping_list,
        {
          vendor_token: vendorToken,
          organization_token: user_token,
        },
        {
          headers: { Authorization: `Bearer ${auth_token}` },
        }
      );

      setMappedItems(res?.data?.items || []);

    } catch (err) {
      console.error(err);
    }
  };

  fetchMappedItems();
}, [vendorToken, auth_token, user_token]);



const normalize = (v) => v?.trim().toLowerCase();
const categories = useMemo(() => {
  return Array.from(
    new Set(
      itemsData
        .map(i => normalize(i.category))
        .filter(Boolean)
    )
  );
}, [itemsData]);

const filteredItems = useMemo(() => {
  if (!selectedCategory) return itemsData;

  const selectedCat = normalize(selectedCategory);

  return itemsData.filter(
    i => normalize(i.category) === selectedCat
  );
}, [itemsData, selectedCategory]);


console.log(filteredItems)


const selectedItemObj = useMemo(() => {
  if (!selectedItem) return null;

  return filteredItems.find(
    i => normalize(i.item_name) === normalize(selectedItem)
  );
}, [filteredItems, selectedItem]);

console.log(selectedItemObj)


  const handleCategorySelect = (val) => {
    const category = String(val).trim();
    setSelectedCategory(category);
    setSelectedItem("");
  };

   const handleItemSelect = (val) => {
    setSelectedItem(String(val).trim());
  };

const handleSave = async () => {
  try {
    setLoading(true);

    await axios.post(
      API_ENDPOINT.item_vendor_mapping_create,
      {
        vendor_token: vendorToken,
        organization_token: user_token,
        item_token: selectedItemObj?.token,
      },
      { headers: { Authorization: `Bearer ${auth_token}` } }
    );

    setMappedItems(prev => [
      ...prev,
      {
        mapping_token: Date.now(),
        category: selectedItemObj.category,
        item_name: selectedItemObj.item_name,
        created_date: new Date().toISOString(),
      },
    ]);

    setSelectedCategory("");
    setSelectedItem("");

    setStatus({
      show: true,
      type: "success",
      message: "Item mapped successfully",
    });
  } catch (err) {
    console.error(err);
    setStatus({
      show: true,
      type: "error",
      message: "Failed to map item",
    });
  } finally {
    setLoading(false);
  }
};

const handleStatusClose = () => {
  setStatus(prev => ({ ...prev, show: false }));
};

 
  return (

    <>

    <div style={{ width: "40rem", display: "flex", flexDirection: "column", gap: "2rem" }}>
      {/* CATEGORY */}
   <DropdownBtnOutlined
        label={selectedCategory || "Select Item Category"}
        options={categories}
        onClick={handleCategorySelect}
        btnWidth="100%"
      />

      {/* ITEM */}
     <DropdownBtnOutlined
        label={selectedItem || "Select Item Name"}
        options={[
          ...filteredItems.map(i => i.item_name?.trim() || ""),
          
        ]}
        onClick={handleItemSelect}
        btnWidth="100%"
        disabled={!selectedCategory}
      />

      {/* SAVE BUTTON */}
      <DButton
        label="Save Item Mapping"
        loadingState={loading}
        onClick={handleSave}
        buyerBtn={true}
      />

      {error && <span style={{ color: "red" }}>{error}</span>}

{status.show && (
  <Card
    sx={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)", 
      width: 360,
      zIndex: 1300,
      boxShadow: 8,
      borderRadius:5
    }}
  >
    <CardContent
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        textAlign: "center",
        alignItems:"center"
      }}
    >
      

      <Typography variant="h4">
        {status.message}
      </Typography>

      <DButton
        
        label="OK"
        onClick={handleStatusClose}
        buyerBtn={true}
      />
    </CardContent>
  </Card>
)}

</div>

 <div >
  {mappedItems.length > 0 && (
  <TableContainer
    component={Paper}
    sx={{
      mt: 2,
      width: "100%",
      overflowX: "auto",
    }}
  >
    <Table size="small">
      <TableHead >
        <TableRow sx={{ backgroundColor: "#f5f5f5"}}>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold"}}>Sl.No</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold"}}>Category</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold"}}>Item Name</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold"}}>Mapped Date</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {mappedItems.map((item, index) => (
          <TableRow key={item.mapping_token}>
            <TableCell  sx={{fontSize:"14px",}}>{index + 1}</TableCell>
            <TableCell  sx={{fontSize:"14px"}}>{item.category}</TableCell>
            <TableCell  sx={{fontSize:"14px"}}>{item.item_name}</TableCell>
            <TableCell sx={{fontSize:"14px"}}>
              {new Date(item.created_date).toLocaleDateString()}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)}
 </div>
    </>
    



  )

  
}

  




export default VendorItemMapping;
